export function verificarSeAlgoEstaPreenchido(
  formulario: any,
  setOpenPopover: Function,
  onClose: Function
) {
  let cod_formulacao: boolean = Number(formulario?.cod_formulacao ?? 0) > 0
  let cod_marca: boolean = Number(formulario?.cod_marca ?? 0) > 0

  let nome: boolean = String(formulario?.nome ?? '') !== ''
  let aminoacido: boolean = String(formulario?.aminoacido ?? '') !== ''
  let aminoacido_descricao: boolean = String(formulario?.aminoacido_descricao ?? '') !== ''
  let hormonio_regulador: boolean =
    String(formulario?.hormonio_regulador ?? '').toUpperCase() !== ''
  let hormonio_regulador_descricao: boolean =
    String(formulario?.hormonio_regulador_descricao ?? '') !== ''
  let indutor_resistencia: boolean = String(formulario?.indutor_resistencia ?? '') !== ''
  let indutor_resistencia_descricao: boolean =
    String(formulario?.indutor_resistencia_descricao ?? '') !== ''
  let biologicos: boolean = String(formulario?.biologicos ?? '') !== ''
  let biologicos_descricao: boolean = String(formulario?.biologicos_descricao ?? '') !== ''
  let extrato_de_alga: boolean = String(formulario?.extrato_de_alga ?? '') !== ''
  let extrato_de_alga_descricao: boolean =
    String(formulario?.extrato_de_alga_descricao ?? '') !== ''
  let observacao: boolean = String(formulario?.observacao ?? '') !== ''
  let n: boolean = String(formulario?.n ?? '') !== ''
  let p: boolean = String(formulario?.p ?? '') !== ''
  let k: boolean = String(formulario?.k ?? '') !== ''
  let ca: boolean = String(formulario?.ca ?? '') !== ''
  let mg: boolean = String(formulario?.mg ?? '') !== ''
  let s: boolean = String(formulario?.s ?? '') !== ''
  let b: boolean = String(formulario?.b ?? '') !== ''
  let cu: boolean = String(formulario?.cu ?? '') !== ''
  let fe: boolean = String(formulario?.fe ?? '') !== ''
  let mn: boolean = String(formulario?.mn ?? '') !== ''
  let zn: boolean = String(formulario?.zn ?? '') !== ''
  let co: boolean = String(formulario?.co ?? '') !== ''
  let mo: boolean = String(formulario?.mo ?? '') !== ''
  let ni: boolean = String(formulario?.ni ?? '') !== ''
  let si: boolean = String(formulario?.si ?? '') !== ''
  let se: boolean = String(formulario?.se ?? '') !== ''

  let funcoes: boolean = (formulario?.funcoes ?? []).length > 0
  let aplicacoes: boolean = (formulario?.aplicacoes ?? []).length > 0
  let culturas: boolean = (formulario?.culturas ?? []).length > 0

  const possui_campo_preenchido: boolean = Object.values({
    cod_formulacao,
    cod_marca,
    nome,
    aminoacido,
    aminoacido_descricao,
    hormonio_regulador,
    hormonio_regulador_descricao,
    indutor_resistencia,
    indutor_resistencia_descricao,
    biologicos,
    biologicos_descricao,
    extrato_de_alga,
    extrato_de_alga_descricao,
    n,
    p,
    k,
    ca,
    mg,
    s,
    b,
    cu,
    fe,
    mn,
    zn,
    co,
    mo,
    ni,
    si,
    se,
    funcoes,
    aplicacoes,
    culturas,
    observacao,
  }).includes(true)

  if (possui_campo_preenchido) {
    setOpenPopover(true)
  } else {
    onClose(false)
  }
}

export function verificarSeHouveAlteracoes(
  original: any,
  formulario: any,
  setOpenPopover: Function,
  onClose: Function
) {
  function verificarAplicacoes() {
    if ((original?.aplicacoes ?? []).length !== (formulario?.aplicacoes ?? []).length) {
      return false
    }

    let originais = (original?.aplicacoes ?? []).map((item) => item.cod_aplicacao)
    let formularios = (formulario?.aplicacoes ?? []).map((item) => item)

    const originais_ordenados = [...originais].sort((a, b) => a - b)
    const formularios_ordenados = [...formularios].sort((a, b) => a - b)
    return originais_ordenados.every((value, index) => value === formularios_ordenados[index])
  }

  function verificarFuncoes() {
    if ((original?.funcoes ?? []).length !== (formulario?.funcoes ?? []).length) {
      return false
    }

    let originais = (original?.funcoes ?? []).map((item) => item.cod)
    let formularios = (formulario?.funcoes ?? []).map((item) => item)

    const originais_ordenados = [...originais].sort((a, b) => a - b)
    const formularios_ordenados = [...formularios].sort((a, b) => a - b)
    return originais_ordenados.every((value, index) => value === formularios_ordenados[index])
  }

  let cod_formulacao: boolean = Number(original?.cod_formulacao ?? 0) === Number(formulario?.cod_formulacao ?? 0)
  let cod_marca: boolean = Number(original?.cod_marca ?? 0) === Number(formulario?.cod_marca ?? 0)
  let nome: boolean = String(original?.nome ?? '') === String(formulario?.nome ?? '')
  let aminoacido: boolean = String(original?.aminoacido ?? '').replace(/\./g, ',') === String(formulario?.aminoacido ?? '')
  let aminoacido_descricao: boolean = String(original?.aminoacido_descricao ?? '') === String(formulario?.aminoacido_descricao ?? '')
  let hormonio_regulador: boolean =
    String(original?.hormonio_regulador ?? '').replace(/\./g, ',') === String(formulario?.hormonio_regulador ?? '')
  let hormonio_regulador_descricao: boolean =
    String(original?.hormonio_regulador_descricao ?? '') ===
    String(formulario?.hormonio_regulador_descricao ?? '')
  let indutor_resistencia: boolean =
    String(original?.indutor_resistencia ?? '').replace(/\./g, ',') === String(formulario?.indutor_resistencia ?? '')
  let indutor_resistencia_descricao: boolean =
    String(original?.indutor_resistencia_descricao ?? '') ===
    String(formulario?.indutor_resistencia_descricao ?? '')
  let biologicos: boolean =
    String(original?.biologicos ?? '').replace(/\./g, ',') === String(formulario?.biologicos ?? '')
  let biologicos_descricao: boolean =
    String(original?.biologicos_descricao ?? '') === String(formulario?.biologicos_descricao ?? '')
  let extrato_de_alga: boolean =
    String(original?.extrato_de_alga ?? '').replace(/\./g, ',') === String(formulario?.extrato_de_alga ?? '')
  let extrato_de_alga_descricao: boolean =
    String(original?.extrato_de_alga_descricao ?? '') ===
    String(formulario?.extrato_de_alga_descricao ?? '')
  let observacao: boolean =
    String(original?.observacao ?? '') === String(formulario?.observacao ?? '')
  let n: boolean = String(original?.n ?? '').replace(/\./g, ',') === String(formulario?.n ?? '')
  let p: boolean = String(original?.p ?? '').replace(/\./g, ',') === String(formulario?.p ?? '')
  let k: boolean = String(original?.k ?? '').replace(/\./g, ',')=== String(formulario?.k ?? '')
  let ca: boolean = String(original?.ca ?? '').replace(/\./g, ',') === String(formulario?.ca ?? '')
  let mg: boolean = String(original?.mg ?? '').replace(/\./g, ',') === String(formulario?.mg ?? '')
  let s: boolean = String(original?.s ?? '').replace(/\./g, ',') === String(formulario?.s ?? '')
  let b: boolean = String(original?.b ?? '').replace(/\./g, ',') === String(formulario?.b ?? '')
  let cu: boolean = String(original?.cu ?? '').replace(/\./g, ',') === String(formulario?.cu ?? '')
  let fe: boolean = String(original?.fe ?? '').replace(/\./g, ',') === String(formulario?.fe ?? '')
  let mn: boolean = String(original?.mn ?? '').replace(/\./g, ',') === String(formulario?.mn ?? '')
  let zn: boolean = String(original?.zn ?? '').replace(/\./g, ',') === String(formulario?.zn ?? '')
  let co: boolean = String(original?.co ?? '').replace(/\./g, ',') === String(formulario?.co ?? '')
  let mo: boolean = String(original?.mo ?? '').replace(/\./g, ',') === String(formulario?.mo ?? '')
  let ni: boolean = String(original?.ni ?? '').replace(/\./g, ',') === String(formulario?.ni ?? '')
  let si: boolean = String(original?.si ?? '').replace(/\./g, ',') === String(formulario?.si ?? '')
  let se: boolean = String(original?.se ?? '').replace(/\./g, ',') === String(formulario?.se ?? '')

  let funcoes: boolean = verificarFuncoes()
  let aplicacoes: boolean = verificarAplicacoes()

  // let tipo_motorizado: boolean = Boolean(original?.motorizado ?? 0) === Boolean(original?.tipo_motorizado ?? 0);

  const possui_campo_alterado: boolean = Object.values({
    cod_formulacao,
    cod_marca,
    nome,
    aminoacido,
    aminoacido_descricao,
    hormonio_regulador,
    hormonio_regulador_descricao,
    indutor_resistencia,
    indutor_resistencia_descricao,
    biologicos,
    biologicos_descricao,
    extrato_de_alga,
    extrato_de_alga_descricao,
    n,
    p,
    k,
    ca,
    mg,
    s,
    b,
    cu,
    fe,
    mn,
    zn,
    co,
    mo,
    ni,
    si,
    se,
    funcoes,
    aplicacoes,
    observacao,
  }).includes(false)
  if (possui_campo_alterado) {
    setOpenPopover(true)
  } else {
    onClose(false)
  }
}
